import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { SidebarPortal } from '@plone/volto/components';
import { ImageInput } from '@plone/volto/components/manage/Widgets/ImageWidget';
import { flattenToAppURL } from '@plone/volto/helpers';
import Schema from './schema';
import View from './View';

/**
 * Edit do bloco Imagem Principal.
 *
 * Espelha preview_image_link + preview_caption_link do conteúdo
 * (mesmos campos do Painel de Controle / Imagem de Pré-visualização).
 * Usa o mesmo ImageInput do bloco Image padrão do Volto — permite
 * browse no site, drop, upload e URL externa.
 */
const ImagemPrincipalEdit = (props) => {
  const { properties, onChangeField, selected, block, data } = props;
  const previewImage = properties?.preview_image_link;
  const caption = properties?.preview_caption_link || '';

  const handleImageChange = async (id, image) => {
    // ImageInput retorna `image` em vários formatos:
    //  - array de objetos (object_browser)
    //  - objeto único {@id, UID, ...}
    //  - string (URL após upload)
    //  - null (limpar)
    const obj = Array.isArray(image) ? image?.[0] : image;

    // preview_image_link é Relation Choice — backend espera UID string
    const uid = obj?.UID || obj?.uid;
    if (uid) {
      onChangeField('preview_image_link', uid);
      return;
    }
    // fallback: tem path/string mas não UID — tenta @id ou raw string
    if (typeof obj === 'string' && obj) {
      onChangeField('preview_image_link', flattenToAppURL(obj));
      return;
    }
    if (obj && obj['@id']) {
      onChangeField('preview_image_link', flattenToAppURL(obj['@id']));
      return;
    }
    onChangeField('preview_image_link', null);
  };

  const handleCaptionChange = (e) => {
    onChangeField('preview_caption_link', e.target.value);
  };

  const handleClear = () => {
    onChangeField('preview_image_link', null);
    onChangeField('preview_caption_link', null);
  };

  // Preview URL — calculado igual ao View
  const imageUrl = (() => {
    if (typeof previewImage === 'string' && previewImage) {
      return `${flattenToAppURL(previewImage)}/@@images/image/larger`;
    }
    if (previewImage && typeof previewImage === 'object' && previewImage['@id']) {
      return `${flattenToAppURL(previewImage['@id'])}/@@images/image/larger`;
    }
    return null;
  })();

  if (!previewImage) {
    return (
      <>
        <div className={cx('block image align center', data?.align)}>
          <ImageInput
            id="preview_image_link"
            block={block}
            onChange={handleImageChange}
            selected={selected}
            allowExternals={false}
          />
        </div>
        <SidebarPortal selected={selected}>
          <div className="ui form" style={{ padding: '1em' }}>
            <h2 style={{ margin: '0 0 0.5em' }}>Imagem Principal</h2>
            <p style={{ color: '#888', fontSize: '0.85em', margin: 0 }}>
              Selecione uma imagem no corpo do bloco. A escolha alimenta o
              campo <em>Imagem de Pré-visualização</em> do Painel de Controle
              e aparece nos listings de notícias.
            </p>
          </div>
        </SidebarPortal>
      </>
    );
  }

  return (
    <>
      <figure className="ag-news-view__figure">
        <img src={imageUrl} alt={caption || properties?.title || ''} />
        <input
          type="text"
          className="ag-news-view__figcaption-edit"
          placeholder="Adicione uma legenda (opcional)…"
          value={caption}
          onChange={handleCaptionChange}
        />
      </figure>
      <SidebarPortal selected={selected}>
        <div className="ui form" style={{ padding: '1em' }}>
          <h2 style={{ margin: '0 0 0.5em' }}>Imagem Principal</h2>
          <p style={{ color: '#888', fontSize: '0.85em', marginBottom: '1em' }}>
            Sincronizada com <em>Imagem de Pré-visualização</em> do Painel
            de Controle.
          </p>
          <ImageInput
            id="preview_image_link_replace"
            block={`${block}-replace`}
            onChange={handleImageChange}
            selected={selected}
            allowExternals={false}
          />
          <button
            type="button"
            className="ui button basic mini"
            onClick={handleClear}
            style={{ marginTop: '0.75em' }}
          >
            Remover imagem
          </button>
        </div>
      </SidebarPortal>
    </>
  );
};

ImagemPrincipalEdit.propTypes = {
  properties: PropTypes.object,
  data: PropTypes.object,
  onChangeField: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  block: PropTypes.string,
};

// Esquema mantido só pra metadata do Form principal não quebrar
ImagemPrincipalEdit.schema = Schema;
ImagemPrincipalEdit.View = View;

export default ImagemPrincipalEdit;
